import React from 'react';
import { Progress } from 'antd';
import { Link } from 'react-router-dom';
import './CompletionRateAnalytics.less';
import { renderPerStr } from '@/utils/renderUtils';
import i2Math from '@/utils/i2Math';

class CompletionRateAnalytics extends React.Component {
  /**
   * 获取原始数值
   * @param {*} value - 原始值
   * @returns {number} 数值
   */
  getRawValue(value) {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const numValue = typeof value === 'number' ? value : parseFloat(value);
    return isNaN(numValue) ? 0 : numValue;
  }

  /**
   * 获取小数形式（用于 renderPerStr，需要 0-1 之间的值）
   * @param {*} value - 原始值
   * @returns {number} 小数形式（0-1）
   */
  getDecimalValue(value) {
    const rawValue = this.getRawValue(value);
    if (rawValue === 0) {
      return 0;
    }
    // 如果值大于1，说明是百分比形式（0-100），需要除以100
    // 如果值小于等于1，说明已经是小数形式（0-1），直接返回
    return rawValue > 1 ? i2Math.i2Division(rawValue, 100) : rawValue;
  }

  /**
   * 获取百分比数值（用于 Progress 组件，需要 0-100 之间的值）
   * @param {*} value - 原始值
   * @returns {number} 百分比数值（0-100）
   */
  getPercentageValue(value) {
    const decimalValue = this.getDecimalValue(value);
    // 使用 i2Math.i2Multiply 解决精度问题，将小数转换为百分比
    return i2Math.i2Multiply(decimalValue, 100);
  }

  /**
   * 构建查询字符串（用于URL跳转）
   * @param {string} dataKey - 数据字段名
   * @returns {string} 查询字符串，如 "?dataKey=postpartumCare"
   */
  buildQueryString(dataKey) {
    return dataKey ? `?dataKey=${dataKey}` : '';
  }

  render() {
    const { serviceCompletionRateSummaryObj, completionRateConfig = [], queryManager } = this.props;
    const data = serviceCompletionRateSummaryObj?.data || {};
    const { currentQuery } = queryManager
    console.log('data', serviceCompletionRateSummaryObj);
    return (
      <div className="completion-rate-analytics">
        {completionRateConfig.map((config, index) => {
          const rawValue = data[config.dataKey];
          const percentValue = this.getPercentageValue(rawValue);
          const queryString = this.buildQueryString(config.dataKey);
          const linkUrl = `/client/commandCenter/completionRateAnalyticsList${queryString}&date=${currentQuery.date}&store_id=${currentQuery.store_id}`;
          return (
            <div key={config.dataKey || index} className="completion-rate-item" style={{ cursor: 'pointer' }}>
              <Link
                to={linkUrl}
                // target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="completion-rate-title">{config.title}</div>
                <div 
                  className="completion-rate-percentage"
                  style={{ color: config.color }}
                >
                  {renderPerStr(rawValue)}
                </div>
                <Progress
                  percent={percentValue}
                  strokeColor={config.color}
                  trailColor="#e8e8e8"
                  showInfo={false}
                  className="completion-rate-progress"
                />
              </Link>
            </div>
          );
        })}
      </div>
    );
  }
}

export default CompletionRateAnalytics;